    (function () {
      if (customElements.get('bundle-selector')) return;
      class BundleSelector extends HTMLElement {
        connectedCallback() {
          this.optionName = this.dataset.optionName;
          this.optionIndex = parseInt(this.dataset.optionIndex, 10);
          try { this.variants = JSON.parse(this.querySelector('[data-bms-variants]').textContent); } catch (e) { this.variants = []; }
          try { this.config = JSON.parse(this.querySelector('[data-bms-config]').textContent); } catch (e) { this.config = { showSavings: true }; }
          this.cards = Array.from(this.querySelectorAll('.bms__card'));
          this.cards.forEach((card) => card.addEventListener('click', () => this.select(card.dataset.value)));
          this.root = this.closest('product-info') || this.closest('section') || document;
          if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            this.unsub = subscribe(PUB_SUB_EVENTS.variantChange, (evt) => {
              const v = evt && evt.data && evt.data.variant;
              if (v && v.options) this.refresh(v.options); else this.refresh(this.readSelected());
            });
          }
          this.root.addEventListener('change', (e) => {
            if (e.target && e.target.closest && e.target.closest('variant-selects')) setTimeout(() => this.refresh(this.readSelected()), 0);
          });
          this.refresh(this.readSelected());
        }
        disconnectedCallback() { if (this.unsub) this.unsub(); }
        get picker() { return this.root.querySelector('variant-selects'); }
        readSelected() {
          const picker = this.picker; if (!picker) return null;
          const out = [];
          picker.querySelectorAll('fieldset, .product-form__input--dropdown').forEach((group) => {
            const checked = group.querySelector('input:checked');
            const select = group.querySelector('select');
            if (checked) out.push(checked.value); else if (select) out.push(select.value);
          });
          return out.length ? out : null;
        }
        select(value) {
          const picker = this.picker;
          if (!picker) return;
          let target = Array.from(picker.querySelectorAll('input[type="radio"]')).find((i) => i.dataset.optionName === this.optionName && i.value === value);
          if (target) {
            if (!target.checked) { target.checked = true; target.dispatchEvent(new Event('change', { bubbles: true })); }
          } else {
            const sel = Array.from(picker.querySelectorAll('select')).find((s) => s.name === 'options[' + this.optionName + ']');
            if (sel && sel.value !== value) { sel.value = value; sel.dispatchEvent(new Event('change', { bubbles: true })); }
          }
          this.markSelected(value);
        }
        markSelected(value) {
          this.cards.forEach((c) => c.setAttribute('aria-checked', c.dataset.value === value ? 'true' : 'false'));
        }
        hideNativeGroup() {
          const picker = this.picker; if (!picker) return;
          picker.querySelectorAll('fieldset, .product-form__input--dropdown').forEach((g) => {
            const hit = Array.from(g.querySelectorAll('input[type="radio"]')).some((i) => i.dataset.optionName === this.optionName) ||
              Array.from(g.querySelectorAll('select')).some((sl) => sl.name === 'options[' + this.optionName + ']');
            if (hit) g.style.display = 'none';
          });
        }
        refresh(selected) {
          this.hideNativeGroup();
          if (!selected) return;
          this.cards.forEach((card) => {
            const want = selected.slice(); want[this.optionIndex] = card.dataset.value;
            const v = this.variants.find((x) => x.options.every((o, i) => o === want[i]));
            const price = card.querySelector('[data-price]'), cmp = card.querySelector('[data-compare]'), save = card.querySelector('[data-save]'), so = card.querySelector('[data-soldout]');
            if (!v) { card.classList.add('is-unavailable'); so.hidden = false; return; }
            price.textContent = v.price;
            if (v.compare) { cmp.textContent = v.compare; cmp.hidden = false; } else { cmp.hidden = true; }
            if (v.save && this.config.showSavings) { save.textContent = 'Save ' + v.save; save.hidden = false; } else { save.hidden = true; }
            card.classList.toggle('is-unavailable', !v.available); so.hidden = !!v.available;
          });
          this.markSelected(selected[this.optionIndex]);
        }
      }
      customElements.define('bundle-selector', BundleSelector);
    })();
